module.exports = function (left, right, options) {
  // Strict equality. e.g. '1' === 1 // => false.
  return left === right ? options.fn(this) : options.inverse(this);
};
